export var letterSpacingOffsetFix = '_3FErF';